import script from "./ResultFound.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultFound.vue?vue&type=script&setup=true&lang=js"

import "./ResultFound.vue?vue&type=style&index=0&id=92532e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92532e6e"]])

export default __exports__